<template>
  <el-dialog
    :title="$t('deleteServiceProvide.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%">
    <div style="text-align:center">
      <p>{{ $t('deleteServiceProvide.confirmDeleteServiceProvide') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('deleteServiceProvide.cancel') }}</el-button>
      <el-button type="primary" @click="deleteServiceProvide">{{ $t('deleteServiceProvide.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteServiceProvide } from '@/api/dev/serviceProvideApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteServiceProvide',
  data() {
    return {
      dialogVisible: false,
      deleteServiceProvideInfo: {}
    }
  },
  methods: {
    open(serviceProvide) {
      this.deleteServiceProvideInfo = {...serviceProvide}
      this.dialogVisible = true
    },
    async deleteServiceProvide() {
      try {
        this.deleteServiceProvideInfo.shopId = getShopId()
        await deleteServiceProvide(this.deleteServiceProvideInfo)
        this.$message.success(this.$t('deleteServiceProvide.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除服务提供失败:', error)
      }
    }
  }
}
</script>